export default "__VITE_ASSET__duO9p5RU__"